import React, { useEffect, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import CapexVsOpex from "./charts/CapexOpex";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "../../../../components/card/card";
import Degradation from "./charts/degradation";
import Cycle from "./charts/Cycle";
import Capex from "./charts/Capex";
import Opex from "./charts/Opex";
import { useParams } from "react-router-dom";

function Index({ allData }) {
  let { assetId } = useParams();
  const [value1, setValue1] = useState(100000);
  const [value2, setValue2] = useState(90000);
  const [slider1, setSlider1] = useState(40);
  const [slider2, setSlider2] = useState(60);
  const [assetGroup, setAssetGroup] = useState("All");
  const [asset, setAsset] = useState("All");
  const [criticality, setCriticality] = useState("All");
  const [strategy, setStrategy] = useState("All");
  const [valueRandom, setValueRandom] = useState(0);
  useEffect(() => {
    setValueRandom(valueRandom + 1);
  }, [asset, assetGroup, criticality, strategy]);
  const formatNumber = (num) => {
    if (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
  };
  return (
    <div>
      <div className={"page-break"}>
        <div className="row content matar">
          {allData.map((item, index) => (
            <div className="col-sm-6  mb-3">
              <Card
                className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}
              >
                <CardHeader>
                  <h5>RUL Graph - {item.name}</h5>
                </CardHeader>
                <CardBody>
                  <Degradation assetId={assetId} allData={item.data} />
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>
      <div className={"page-break"}>
        <div className="row matar content">
          {allData.map((item, index) => (
            <div className="col-sm-6  mb-3">
              <Card
                className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}
              >
                <CardHeader>
                  <h5>Lifecycle Cost - {item.name}</h5>
                </CardHeader>
                <CardBody>
                  <Cycle assetId={assetId} allData={item.data} />
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>

      <div className={"page-break"}>
        <div className="row matar content">
          {allData.map((item, index) => (
            <div className="col-sm-6  mb-3">
              <Card
                className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}
              >
                <CardHeader>
                  <h5>Capex - {item.name}</h5>
                </CardHeader>
                <CardBody>
                  <Capex assetId={assetId} allData={item.data} />
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>

      <div className={"page-break"}>
        <div className="row matar content">
          {allData.map((item, index) => (
            <div className="col-sm-6  mb-3">
              <Card
                className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}
              >
                <CardHeader>
                  <h5>Opex {item.name}</h5>
                </CardHeader>
                <CardBody>
                  <Opex assetId={assetId} allData={item.data} />
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Index;
